// Module
var code = "<div layout=\"row\" layout-align=\"start center\"> <md-radio-button flex class=\"md-accent radio-item\" ng-disabled=\"!!$ctrl.isExcluded\" ng-value=\"$ctrl.consolidatedCommission.id\"> <div layout=\"column\"> <span>{{$ctrl.consolidatedCommission.name}}</span> <span>{{$ctrl.consolidatedCommission.id}}</span> </div> </md-radio-button> </div> ";
// Exports
export default code;